import React from "react";
import { FormControlProps } from "./types";
import { useData, useDataValue } from "../hooks/useData";
import { closestIndex } from "../utils/dom";


export function List<T>(props: FormControlProps & {

	className?: string,

	blankOption?: {
		value: any,
	}

    multiSelect?: boolean,
    selectAllOption?: boolean,

    items: T[],
    getValue: (item: T) => any,
	getDisplay: (item: T, selected: boolean) => any,
    //renderItem: (item: T, selected: boolean) => any,

    onChange?: (e: any, selected?: T) => void,

    style?: any,

}) {

    const data = useData();
    const value = useDataValue(data, props.prop);

    const {
        items, getValue, getDisplay, style
    } = props;

    const listItems = [];

	const itemClass = "item flex horiz clickable fill show-hover ";

	if (props.blankOption) {
		listItems.push(
			<div
				className={itemClass}
				data-index={-1}
				key={"blank"}
			>&nbsp;</div>
		);
	}

    if (items && items.length > 0) {
        for(let i=0;i<items.length;i++) {
            const item = items[i];

            let selected = props.multiSelect ? 
                (value && value.indexOf && value.indexOf(getValue(item)) >= 0)
                : (getValue(item) === value);

            listItems.push(
                <div
                    className={itemClass + (selected ? " selected" : "")}
                    data-index={listItems.length - (props.blankOption ? 1 : 0)}
                    key={listItems.length}
                >{getDisplay(item, selected)}</div>
            )
        }

        if (props.selectAllOption) {
            listItems.push(
                <div
                    className={itemClass}
                    data-index={listItems.length}
                    key={listItems.length}
                ><div className="tag">All</div></div>
            )
        }
    }

    function handleClick(e: any) {
        const index = closestIndex(e.target, ".item");


        if (index === items.length && props.multiSelect) {
            // toggle all
            const newValue: any[] = [];

            if (value && value.length > 0) {
                // none

            } else {
                // all
                for(let item of items) {
                    newValue.push(getValue(item));
                }
            }

            data.setValue(props.prop, newValue);

            if (props.onChange) props.onChange(e);
        
        } else if (index >= 0) {
            const clickedValue = getValue(items[index]);

            if (props.multiSelect) {
                if (!value || !value.length) {
                    data.setValue(props.prop, [clickedValue]);
                } else {
                    const selectedIndex = value.indexOf(clickedValue);
					let arr = value;

                    if (selectedIndex >= 0) {
                        arr.splice(selectedIndex, 1);
                    } else {
						// check in case previous had been single select
						if (!Array.isArray(arr)) {
							// convert to array
							arr = [arr];
						}
                        arr.push(clickedValue);
                    }
                    
					data.setValue(props.prop, [...arr]);
                }

            } else {
                data.setValue(props.prop, clickedValue);

            }

            if (props.onChange) props.onChange(e, items[index]);
        
		} else if (index === -1 && props.blankOption) {
			data.setValue(props.prop, props.blankOption.value);
            if (props.onChange) props.onChange(e, items[index]);
			
		}

    }

    return (
        <div
            className={[
				"form-control bg",
				props.className
			].join(" ")}
            onClick={handleClick}
            style={style}
			tabIndex={0}
        >
            {listItems}
        </div>
    );
}

